import { IconBase, IconComponent } from './BaseIcon';

export const Plus: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M26.02 14.98h-9.01v-9h-2v9h-9v2h9v9h2v-9h9.01v-2z" />
  </IconBase>
);
